<template>
  <div>
    <AdjustDriverDialog ref="adjustDriverDialog" />
    <AdjustTimestampsDialog ref="adjustTimestampsDialog" />

    <GenericReport
      v-if="value.organizationId != -1 && value.vehicleId != null"
      ref="report"
      class="maxh-1bar clean-list"
      hide-header
      orientation="horizontal"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :extraParams="{ vehicleIds: value.vehicleId }"
      @rowClicked="showRowDetails"
      selectable
      @update:selectedIndexes="(x) => (selectedIndexes = x)"
      @update:selected="(x) => (selectedIds = x)"
      rememberLastClick
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <OMenuButton :menuOpts="menuOpts" />
      </template>
    </GenericReport>

    <OJumbo question v-else>
      Este módulo não está associado a nenhum veículo ou organização.
    </OJumbo>
  </div>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { fullSpec } from '../../vehicle/trip-columns'
import { OrgApi } from '@/models'
import moment from 'moment'
import AdjustDriverDialog from './AdjustDriverDialog.vue'
import AdjustTimestampsDialog from './AdjustTimestampsDialog.vue'

export default {
  tabTitle: 'Trechos',
  tabGroup: 'Veículo',
  tabBadgeFn: async (client) => {
    let orgId = client.organizationId
    let vehicleId = client.vehicleId
    if (vehicleId == null || orgId == -1) return null

    let res = await new OrgApi(orgId).get('trips', {
      vehicleIds: vehicleId,
      fromDate: moment()
        .add(-15, 'd')
        .toDate(),
      untilDate: new Date(),
      driverIds: 0,
      limit: 1,
      isValid: true
    })

    if (res.count != 0) {
      return {
        text: res.count,
        color: 'red',
        alt: '(Motorista Desconhecido nos últimos 15 dias)'
      }
    }
  },
  components: {
    GenericReport,
    AdjustDriverDialog,
    AdjustTimestampsDialog
  },
  props: {
    value: { required: true }
  },
  data() {
    return { adapterSpec: fullSpec, selectedIndexes: [], selectedIds: [] }
  },
  computed: {
    menuOpts() {
      return [
        {
          text: 'Exportar CSV',
          icon: 'mdi-file-delimited-outline',
          onClick: () => this.$refs.report.checkDownload()
        },
        {
          text: 'Ajustar Motorista...',
          icon: 'mdi-account-circle',
          disabled: this.selectedIds.length < 1,
          onClick: () => {
            this.$refs.adjustDriverDialog.open(
              this.selectedIndexes,
              this.selectedIds,
              this.value.organizationId
            )
          }
        },
        {
          text: 'Ajustar Datas...',
          icon: 'mdi-clock',
          disabled: this.selectedIds.length != 1,
          onClick: () => {
            this.$refs.adjustTimestampsDialog.open({
              orgId: this.value.organizationId,
              tripId: this.selectedIds[0]
            })
          }
        }
      ]
    },
    reportSpec() {
      let orgId = this.value.organizationId
      let apiBase = `/organizations/${orgId}/api/v1/trips`
      return {
        code: 'trips',
        title: 'Trechos',
        apiBase,
        filters: ['DateRange'],
        orderByOptions: [
          {
            value: 'startTimestamp desc, id desc',
            text: 'Data de início mais recente'
          },
          {
            value: 'createdAt desc, id desc',
            text: 'Criados mais recentes no começo'
          },
          {
            value: 'updatedAt desc, id desc',
            text: 'Atualizados mais recentes no começo'
          }
        ]
      }
    }
  },
  methods: {
    showRowDetails({ row }) {
      this.$vis({
        tripId: row.id,
        orgId: this.value.organizationId
      })
    }
  }
}
</script>

<style></style>
